import React, {Component} from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import MUIDataTable from 'mui-datatables';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { isEmptyObject } from 'jquery';

import withNotification from '../../components/HOCNotification/HOCNotification.component';
import Services from '../../services/service';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { getMuiTheme, tableOptions } from '../../util/MuiTableTheme';
import { MODALACTION } from '../../config/constants';
import LayoutMapper from '../../components/LayoutMapper/LayoutMapper.component';

const { CREATE, EDIT, DELETE, VIEW } = MODALACTION;

class LayoutBuilding extends Component {
  constructor(props){
    super(props);

    this.state = {
      listLayout: [],
      addModal: false,
      selectedItem: {},
      actionModal: '',
      name: '',
      file: '',
      buildingList: [],
      floorList: [],
      floor: '',
      building: '',
      code: ''
    };
  }

  componentDidMount(){
    this.getAllData();
    this.getBuildingList();
    this.getFloorList();
  }

  getBuildingList = () => {
    Services.getList({param: 'building-category'})
      .then(res => {
        this.setState({buildingList: res});
      })
      .catch(err => console.log(err))
  };

  getFloorList = () => {
    Services.getList({param: 'building-floor'})
      .then(res => {
        this.setState({floorList: res});
      })
      .catch(err => console.log(err))
  };

  getAllData = () => {
    Services.getAllLayout()
      .then(res => {
        this.setState({ listLayout: res })
      })
      .catch(err => this.props.addNotification('danger', 'Failed', 'Oops something went wrong !', 'top-right'));
  };


  handleFieldChange = (key) => (e) => {
    const state = { [key]: e.target.value };
    this.setState(state);
  };

  selectFile = (event) => {
    console.log(event.target.files[0].name)
    this.setState({
      file: event.target.files,
    });
  };

  handleSubmitData = () => {
    const { name, building, code, floor, file, actionModal } = this.state;
    let formData =  new FormData();

    formData.append("name", name);
    formData.append("building", building);
    formData.append("code", code);
    formData.append("floor", floor);
    formData.append("file", file[0]);

    Services.postLayout(formData)
      .then(res => {
        this.props.addNotification('success', 'Success', `${actionModal} Layout successfull`, 'top-right');
        this.toggleAddModal();
        this.getAllData();
      })
      .catch(err => {
        this.props.addNotification('danger', 'Failed', 'Oops something went wrong !', 'top-right');
      });
  };

  handleUpdateData = () => {
    const { name, file, actionModal, selectedItem, code, building, floor } = this.state;
    let formData =  new FormData();
    const updatedName = name === '' ? selectedItem.name : name;
    const updatedCode = code === '' ? selectedItem.code : code;
    const updatedFloor = floor === '' ? selectedItem.floorId : floor;
    const updatedBuilding = building === '' ? selectedItem.buildingId : building;
    const updatedFile = file === '' ? selectedItem.file : file[0];
    const param = { params: { layoutZoneId: selectedItem._id }};
    

    formData.append("name", updatedName);
    formData.append("code", updatedCode);
    formData.append("building", updatedBuilding);
    formData.append("floor", updatedFloor);
    formData.append("file", updatedFile);

    Services.updateLayout(formData, param)
      .then(res => {
        this.props.addNotification('success', 'Success', `${actionModal} Layout successfull`, 'top-right');
        this.toggleAddModal();
        this.getAllData();
      })
      .catch(err => {
        this.props.addNotification('danger', 'Failed', 'Oops something went wrong !', 'top-right');
      });
  };

  handleDeleteData = () => {
    const { actionModal, selectedItem } = this.state;
    const param = { params: { layoutZoneId: selectedItem._id }};

    Services.deleteLayout(param)
      .then(res => {
        this.props.addNotification('success', 'Success', `${actionModal} Layout successfull`, 'top-right');
        this.toggleAddModal();
        this.getAllData();
      })
      .catch(err => {
        this.props.addNotification('danger', 'Failed', 'Oops something went wrong !', 'top-right');
      });;
  }

  renderBreadcrumb = () => (
    <div>
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
        <li className="breadcrumb-item active">Layout</li>
      </ol>
      <h1 className="page-header">Layout Building </h1>
    </div>
  );

  renderRoleTable = () => {
    const { listLayout } = this.state;

    const columns = [
      {
        name: "no",
        label: "No",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta) => tableMeta.rowIndex + 1
        }
      },
      {
        name: "name",
        label: "Nama",
        options: {
          filter: true,
          sort: true
        }
      },
      {
        name: "file",
        label: "File Name",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "createDate",
        label: "Created Date",
        options: {
          filter: true,
          sort: true,
          customBodyRender: value => moment(value).format('DD-MM-YYYY')
        }
      },
      {
        name: "Action",
        options: {
          filter: false,
          sort: false,
          setCellProps: () => ({ style: { minWidth: "200px", maxWidth: "200px" }}),
          customBodyRender: (value, tableMeta) => {
            return (
              <div className="with-btn text-nowrap">
                {/* <Link
                  to={{
                    pathname: '/setting/list-menu',
                    state: {
                      selectedItem: listLayout[tableMeta.rowIndex]
                    }
                  }}
                >
                  <button className="btn btn-sm btn-lime width-60 m-r-2" onClick={() => {} }>DETAIL</button>
                </Link> */}
                <button 
                  className="btn btn-sm btn-success width-60 m-r-2"
                  onClick={() => this.togglePreviewLayout(listLayout[tableMeta.rowIndex])}
                >{VIEW}</button>
                <button 
                  className="btn btn-sm btn-primary width-60 m-r-2"
                  onClick={() => this.toggleAddModal(EDIT, listLayout[tableMeta.rowIndex])}
                >{EDIT}</button>
                <button
                  onClick={() => this.toggleAddModal(DELETE, listLayout[tableMeta.rowIndex])}
                  className="btn btn-sm btn-danger width-70 m-r-2">{DELETE}</button>
              </div>
            );
          }
        }
      }
    ];

    const options = {
      ...tableOptions,
      customToolbar: () => (
        <button className="btn btn-sm btn-primary width-70" onClick={() => this.toggleAddModal(CREATE)}>Add</button>
      ),
    };
      
    return (
      <MuiThemeProvider theme={getMuiTheme()}>
        <MUIDataTable
          title={"List Layout"}
          data={listLayout}
          columns={columns}
          options={options}
        />
      </MuiThemeProvider>
    )
  };

  toggleAddModal = (action='', item={}) => {
    this.setState({ 
      addModal: !this.state.addModal,
      name: '',
      file: '',
      actionModal: action,
      selectedItem: item
    });
  };

  setHeaderItemText = (value) => {
    switch (value) {
      case CREATE :
        return 'Add Layout';
      case EDIT :
        return 'Edit Layout';
      case DELETE : 
        return 'Are you sure want to delete ?';
      default:
        return '';
    }
  }

  setActionButton = (e, value) => {
    e.preventDefault();
    switch (value) {
      case CREATE :
        this.handleSubmitData();
        break;
      case EDIT :
        this.handleUpdateData();
        break;
      case DELETE : 
        this.handleDeleteData();
        break;
      default:
        break;
    }
  }

  renderAddModal = () => {
    const { addModal, name, selectedItem, actionModal, code, building, floor } = this.state;
    const textHeader = this.setHeaderItemText(actionModal);
    const filled = isEmptyObject(selectedItem);
    let buildingOptions = this.state.buildingList.length > 0
    && this.state.buildingList.map((item, i) => {
      return (
        <option key={i} value={item.id}>{item.name}</option>
      )
    }, this);
    let floorOptions = this.state.floorList.length > 0
    && this.state.floorList.map((item, i) => {
      return (
        <option key={i} value={item.id}>{item.name}</option>
      )
    }, this);

    return (
      <Modal isOpen={addModal} toggle={() => this.toggleAddModal()}>
        <ModalHeader toggle={() => this.toggleAddModal()}>{textHeader}</ModalHeader>
        <form onSubmit={(e) => this.setActionButton(e, actionModal)}>
        <ModalBody>
          <div className="form-group">
          <label>Name</label>
          <input 
            onChange={this.handleFieldChange('name')}
            type="text"
            className="form-control"
            defaultValue={!filled ? selectedItem.name : name}
            disabled={actionModal === DELETE}
            required
          />
          </div>
          <div className="form-group">
            <label>Code</label>
            <input 
              onChange={this.handleFieldChange('code')}
              type="text"
              className="form-control"
              defaultValue={!filled ? selectedItem.code : code}
              disabled={actionModal === DELETE}
              required
            />
          </div>
          <div className="form-group">
            <label>Building</label>
            <select
              onChange={this.handleFieldChange('building')}
              type="select" className="form-control"
              defaultValue={!filled ? selectedItem.buildingId : building }
              disabled={actionModal === DELETE}
            >
              <option disabled value=''> - pilih - </option>
              {buildingOptions}
            </select>
          </div>
          <div className="form-group">
            <label>Floor</label>
            <select
              onChange={this.handleFieldChange('floor')}
              type="select" className="form-control"
              defaultValue={!filled ? selectedItem.floorId : floor }
              disabled={actionModal === DELETE}
            >
              <option disabled value=''> - pilih - </option>
              {floorOptions}
            </select>
          </div>
          { actionModal !== DELETE && (
            <>
              <label>File</label>
              <input
                onChange={this.selectFile}
                type="file"
                className="form-control"
                required={actionModal === CREATE }
                accept="image/jpe, image/jpg, image/jpeg, image/png"
              />
            </>
            )
          }
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-white" onClick={() => this.toggleAddModal()}>Cancel</button>
          <button className="btn btn-primary" type="submit">{actionModal}</button>
        </ModalFooter>
        </form>
      </Modal>
    )
  }

  togglePreviewLayout = (layout) =>{
    this.setState({
      showModalPreview: !this.state.showModalPreview,
      selectedItem: layout? layout: null,
    });
  }

  renderModalPreviewLayout = () =>{
    const headerText = `${this.state.selectedItem.name} - ${this.state.selectedItem.building} - ${this.state.selectedItem.floor}`;
    return (
      <Modal size='xl' isOpen={this.state.showModalPreview} toggle={() => this.togglePreviewLayout()}>
        <ModalHeader toggle={() => this.togglePreviewLayout()}>{headerText}</ModalHeader>
        <ModalBody>
          <LayoutMapper selectedLayout={this.state.selectedItem._id}/>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-white" onClick={() => this.togglePreviewLayout()}>Tutup</button>
        </ModalFooter>
      </Modal>
    )
  }

  render(){
    return (
      <div>
        {this.renderBreadcrumb()}
        {this.renderRoleTable()}
        {this.renderAddModal()}
        {this.state.showModalPreview &&
          this.renderModalPreviewLayout()
        }
      </div>
    )
  }
};


export default withNotification(LayoutBuilding);
